module.exports = __webpack_public_path__ + "static/media/ic_erazer.66683917.svg";